// extracted by mini-css-extract-plugin
export default {"btnSave":"styles_btnSave__JyKRb","btnPrev":"styles_btnPrev__OLvoO","btnNext":"styles_btnNext__zwMMN","btnSubmit":"styles_btnSubmit__3Vs+0","displayNone":"styles_displayNone__DxPki"};